<template>
    <baby 
        :weight="2 * weight / (max_weight + min_weight)"
        :height="2 * height / (max_height + min_height)"
        :gender="gender"
        :color="color"/>
</template>

<script>
import Baby from '@/components/baby/Baby'
export default {
    props: {
        weight: Number,
        height: Number,
        gender: String,
        color: Object
    },
    data () {
        return {
            min_weight: 2500,
            max_weight: 6000,
            min_height: 40,
            max_height: 60,
        }
    },
    components: {
        Baby
    },
}
</script>
